<template>
  <el-card class="box-card progress-dialog-content" v-show="show">
    <div class="title-wrap" slot="header">
      <!-- <i class="icon"></i> -->
      <span class="text ">进度条列表</span>
      <i class="icon-close" title="关闭" @click="setShow(false)">
        <icon-base
          :icon-name="Icons.PopupClose.iconName"
          v-bind="Icons.PopupClose"
        >
          <icon-popup-close
            class="path-icon-close"
            :icon-name="Icons.PopupClose.iconName"
            v-bind="Icons.PopupClose"
          />
        </icon-base>
      </i>
    </div>
    <div class="p-list scroll-bar" ref="pList">
      <div class="p-wrap" v-for="(p) in pList" :key="p.porcessId">
        <span class="label ellipsis" :title="p.name">{{ p.name }}</span>
        <el-progress :percentage="p.progress"></el-progress>
      </div>
    </div>
  </el-card>
</template>

<script>
import IconPopupClose from '@/components/icons/typography/PopupClose'
export default {
  name: 'progressDialog',
  components: { IconPopupClose },
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (val) => ['info', 'success', 'warning', 'error'].includes(val),
    },
  },
  data() {
    return {
      show: false,
      text: '',
      pList: [
        // {
        //   porcessId: '111',
        //   name: '数据集1',
        //   progress: 50,
        //  show:false,
        // },
      ],
      Icons: {
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"
        },
      },
      duration: 5000,
    }
  },
  computed: {},
  watch: {
    show(bool) {
      // if (bool) {
      //   setTimeout(() => {
      //     this.show = false
      //   }, this.duration)
      // }
    },
  },
  created() {},
  mounted() {},
  methods: {
    setShow(bool) {
      this.show = bool
    },
    setText(text) {
      this.text = text
    },
    addPorcess(porcess) {
      this.pList.unshift(porcess)
  
      if (!this.show) {
        this.show = true
      }
    },
    // scrollToBottom() {
    //   this.$refs.pList.scrollTop = this.$refs.pList.scrollHeight
    // },
    //监听一个进程
    onPorcess(porcessId, progress) {
      this.$nextTick(() => {
        this.pList.map((p) => {
          if (p.porcessId == porcessId) {
            p.progress = progress
          }
          return p
        })
      })
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  beforeDestroy() {}, //生命周期 - 销毁之前

  activated() {},
}
</script>
<style lang="scss" scoped>
.progress-dialog-content {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 30%;
  max-width: 300px;
  // width: 30%;
  // height: inherit;
  height: 40%;
  background: #fff;
  // border-left: 1px solid #999;
  // border-top: 1px sollid #999;
  z-index: 999;
  ::v-deep .el-card__header {
    padding: 10px 20px;
    .title-wrap {
      // margin: 10px;
      font-weight: 700;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .icon-close {
        width: 30px;
        height: 30px;
        margin-left: auto;
        vertical-align: middle;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        &:hover::v-deep .path-icon-close {
          fill: #4c88ff;
        }
      }
    }
  }
  ::v-deep .el-card__body {
    height: calc(100% - 80px);
    .p-list {
      height: 100%;
      overflow: auto;
      padding: 5px 0;
      .label {
        max-width: 240px;
        display: inline-block;
      }
    }
  }
}
</style>
